
import styled from 'styled-components';

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
`;

export const StyledAlertContainer = styled.div`
  margin-bottom: 16px;
`;
